import { render, staticRenderFns } from "./TeamsDropdownItem.vue?vue&type=template&id=26a45f53&scoped=true&"
import script from "./TeamsDropdownItem.vue?vue&type=script&lang=js&"
export * from "./TeamsDropdownItem.vue?vue&type=script&lang=js&"
import style0 from "./TeamsDropdownItem.vue?vue&type=style&index=0&id=26a45f53&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a45f53",
  null
  
)

export default component.exports